<template>

  <div id="how-works">

    <div class="container">
      <div class="row">
        <h2>A Click2Giv quer empoderar quem faz e quer fazer ainda mais o bem.</h2>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="icon">
            <font-awesome-icon class="fa" :icon="['fas', 'users']" size="lg" />
          </div>
          <h4>O que nos move é a compaixão</h4>
          <p>
            Somos apaixonados por pessoas. Queremos dar voz às Organizações Sociais e transformar vidas. 
            Criar abundância de sonhos e transformações. 
            Acreditamos que a soma pode trazer paz ao desespero, esperança ao abandono e felicidade à tristeza.
          </p>
        </div>
        <div class="col-md-6">
          <div class="icon">
            <font-awesome-icon class="fa" :icon="['fas', 'donate']" size="lg" />
          </div>
          <h4>Fazer o bem , faz bem para você!</h4>
          <p>
            Doação é quando fazemos o bem para o próximo sem esperar nada em troca. 
            Quando ajudamos ao próximo estamos ajudando a nós mesmos. A soma de pequenas doações faz a diferença na vida de muita gente.
            Nossa plataforma permite doações de forma pontual ou recorrente, através de diferentes meios de pagamentos, como cartões de crédito, débito e boleto bancário.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="icon">
            <font-awesome-icon class="fa" :icon="['fas', 'desktop']" size="lg" />
          </div>
          <h4>Plataforma Digital</h4>
          <p>
            Ferramentas de comunicação, relacionamento e divulgação, integrada à redes sociais em um único ambiente.
            Fácil de usar e simples como deve ser. Acreditamos no poder da comunicação para ampliar o conceito de doação, engajamento e fraternidade.
          </p>
        </div>
        <div class="col-md-6">
          <div class="icon">
            <font-awesome-icon class="fa" :icon="['fas', 'share-square']" size="lg" />
          </div>
          <h4>Compartilhe e receba atualizações</h4>
          <p>
            Acreditamos que cada um é tocado por algo diferente. 
            Escolha uma categoria, conheça as Organizações Sociais, assista aos vídeos e ajude como puder.
            Compartilhe com seus amigos, receba atualizações e colabore na divulgação da Organização Social que você admira.
          </p>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
export default{
  components: {
    FontAwesomeIcon
  },
  data(){
    return {

    }
  }
}
</script>

<style scoped lang="scss">
#how-works{
  background-color: #e1e1e1;
  min-height: 300px;
  padding-top: 50px;
  padding-bottom: 50px;

  .row{
    margin-top: 20px;
  }

  h2{
    width: 100%;
    text-align: center;
    font-family: RalewayBold;
    color: #00AE39;
  }

  h4{
    font-family: RalewayRegular;
    text-align: center;
    color: #00AE39;
    margin-top: 20px;
  }

  .icon{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: #fff;
    margin: 0 auto;
    position: relative;

    .fa{
      position: absolute;
      font-size: 90px;
      width: 120px;
      top: 50px;
      left: 40px;
      color: #00AE39;
    }
  }

  p{
    margin-top: 20px;
    font-family: RalewayRegular;
    text-align: justify;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/home/HowWorksSection.vue